import apiFetch from '../apiFetch'

export default function (entityId, token) {
  return apiFetch({ endPoint: `entity/${entityId}`, method: 'DELETE', body: null, token: token })
}
